export default "__VITE_ASSET__ChAvchUG__"